exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3395cdec]:export{menu-bgc-oragne:#F2C46D}.spwwMainContPage[data-v-3395cdec]{flex:1;padding-top:192px;width:1000px;margin:0 auto}\n", ""]);

// exports
